import { overlayHide, overlayShow } from 'Components/Overlay';

export default class LoadingIndicator {
  constructor(parent, { label = '' } = {}) {
    this.root = (
      <div class="loading-indicator overlay" hidden>
        <div class="loading-indicator-img" role="alert" aria-busy="true"></div>
        {label && <strong>{label}</strong>}
      </div>
    );

    parent.appendChild(this.root);
  }

  hide() {
    overlayHide(this.root);
  }

  show() {
    overlayShow(this.root, true);
  }

  toggle(flag) {
    if (flag) {
      this.show();
    } else {
      this.hide();
    }
  }
}
